const appData = {
  googleMapApiKey: "AIzaSyBjnsedFLB4nVkgtsi5nl3fMcCHxLcDMVI",
};
export default appData;
